// Charge `external_api.js` depuis le domaine Jitsi fourni par le core
// (option B : on n'embarque pas le SDK, on l'injecte dynamiquement, ce
// qui evite de figer le domaine au build time).
let loadingPromise: Promise<void> | null = null;
let loadedDomain: string | null = null;

export function loadJitsiExternalApi(domain: string): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("window indisponible"));
  }

  if (loadedDomain === domain && window.JitsiMeetExternalAPI) {
    return Promise.resolve();
  }

  if (loadingPromise && loadedDomain === domain) {
    return loadingPromise;
  }

  loadedDomain = domain;
  loadingPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[data-jitsi-external-api="${domain}"]`,
    );
    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener(
        "error",
        () => reject(new Error("Echec chargement external_api.js")),
        { once: true },
      );
      return;
    }

    const script = document.createElement("script");
    script.src = `https://${domain}/external_api.js`;
    script.async = true;
    script.dataset.jitsiExternalApi = domain;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Echec chargement external_api.js"));
    document.head.appendChild(script);
  });

  return loadingPromise;
}

export interface JitsiExternalApi {
  dispose(): void;
  addListener(event: string, listener: (...args: unknown[]) => void): void;
  removeListener(event: string, listener: (...args: unknown[]) => void): void;
  executeCommand(command: string, ...args: unknown[]): void;
}

export interface JitsiExternalApiOptions {
  roomName: string;
  jwt?: string;
  parentNode?: HTMLElement;
  width?: string | number;
  height?: string | number;
  userInfo?: { displayName?: string; email?: string };
  configOverwrite?: Record<string, unknown>;
  interfaceConfigOverwrite?: Record<string, unknown>;
}

declare global {
  interface Window {
    JitsiMeetExternalAPI?: new (
      domain: string,
      options: JitsiExternalApiOptions,
    ) => JitsiExternalApi;
  }
}
